import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DocumentSearch } from "../../../app/document/models/documentSearch";
import { ApiConstants } from "../constants/api-constants";
import { SharedConstants } from "../constants/shared-constants";

@Injectable({
    providedIn: 'root'
  })
export class DocumentSearchService {
    searchCriteria : any;
    fileData:any;

    constructor(private httpClient:HttpClient) {
    }

    getDocumentLibraryExport(documentSearchCriteria: DocumentSearch): Observable<any> {
        return this.httpClient.post(
          ApiConstants.Document_Export_Api, documentSearchCriteria);
      }

exportToExcel(exportPayload: any) {
    this.getDocumentLibraryExport(exportPayload).subscribe((data) => {
      this.fileData = data;
      let byteData = this.fileData;
      const byteCharacters = atob(byteData);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      let blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      var fileName = SharedConstants.Doc_Library_Export_FileName.replace("DATE", this.date_TO_String(new Date()));
      anchor.download = fileName;
      anchor.href = url;
      anchor.click();
    });
  }

 date_TO_String(date_Object: Date): string {
    // get the year, month, date, hours, and minutes seprately and append to the string.
    let date_String: string =
      date_Object.getFullYear() +
      "_" +
      (date_Object.getMonth() + 1) +
      "_" +
      +date_Object.getDate();
    return date_String;
  }

}
